import axios from "axios";
import base_url from "./bootapi";

//credentials: "include",
const publicFetch = axios.create({
  baseURL: base_url,
  headers: {
    "Content-type": "application/json",
  },
});

/* // Add a request interceptor
publicFetch.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
publicFetch.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  alert('Error in Intercepter Response:'+ JSON.stringify(error))
  return Promise.reject(error);
}); */

export { publicFetch };
